import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  SnackbarContent,
} from '@material-ui/core'
import {Redirect} from 'react-router-dom'
import classNames from 'classnames'
import {Formik} from 'formik'
import {FuseAnimate} from '@fuse'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import {
  FormikTextField,
  GridItem,
} from '../project/ecommerce/storeSettings/components/common'
import {FORGOT_PASSWORD} from '../../../graphql/mutation'

const styles = _theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class ForgotPasswordPage extends Component {
  state = {
    login: false,
    sendEmail: false,
  }

  handleSubmitForgotPassword = async (forgotPassword, values) => {
    try {
      await forgotPassword({
        variables: {
          email: values.email,
        },
      })
      this.setState({ sendEmail: true })
    } catch (resetPasswordError) {
      resetPasswordError.graphQLErrors.forEach(
        ({message}) => {
          toast.error(message, {
            position:
              toast.POSITION.BOTTOM_RIGHT,
          })
        },
      )
      this.setState({ sendEmail: false })
    }
  }

  handleClickSignin = () => {
    this.setState({login: true})
  }

  render() {
    const {classes} = this.props
    if (this.state.login) {
      return <Redirect to="/login" />
    }
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                <img
                  className="w-128 m-32"
                  src="assets/images/logos/deeple_dark.png"
                  alt="logo"
                />

                <Typography variant="title" className="mt-16 mb-32">
                  Reset Password
                </Typography>

                <Mutation
                  mutation={FORGOT_PASSWORD}
                >
                  {forgotPassword => {
                    return <Formik
                      enableReinitialize
                      initialValues={{
                      email: '',
                    }}
                      onSubmit={values => {
                      this.handleSubmitForgotPassword(forgotPassword, values)
                    }}
                      render={props => (
                        <form onSubmit={props.handleSubmit}>
                          <Grid container spacing={16}>
                            <Grid item xs={12}>
                              <Grid
                                container
                                justify="flex-start"
                                alignItems="center"
                                spacing={16}
                              >
                                <GridItem item xs={12}>
                                  <FormikTextField
                                    onChange={props.handleChange}
                                    onBlur={props.handleBlur}
                                    value={props.values.email}
                                    errors={props.errors}
                                    touched={props.touched}
                                    type="email"
                                    name="email"
                                    label="Email"
                                    fullWidth
                                  />
                                </GridItem>
                                {this.state.sendEmail &&
                                  <SnackbarContent
                                    aria-describedby="client-snackbar"
                                    message="Your password reset email has been sent!, Please check your inbox to continue."
                                  />
                                }
                                <Grid
                                  container
                                  justify="space-between"
                                >
                                  <Button
                                    color="secondary"
                                    className="mt-16"
                                    aria-label="Sign-In"
                                    onClick={this.handleClickSignin}
                                  >
                                    Sign-In
                                  </Button>
                                  <Button
                                    variant="raised"
                                    type="submit"
                                    color="primary"
                                    className="w-224 mt-16"
                                    aria-label="Reset Password"
                                    disabled={!props.values.email.length}
                                  >
                                    Reset Password
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    />
                  }}
                </Mutation>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(ForgotPasswordPage)



// WEBPACK FOOTER //
// ./src/main/content/login/ForgotPasswordPage.js